<i18n>
    {
        "ru": {
            "in": "в"
        }
    }
</i18n>
<template>
    <article class="article-item"
        :class="rootClasses">
        <div class="article-item__picture-block">
            <div class="article-item__picture-wrapper">
                <img class="article-item__picture"
                    v-lazy-load :data-src="computedPicture"
                    v-bind="size"
                    :alt="get(data, 'picture.alt')" />
            </div>
            <div class="article-item__publish-date"
                v-if="isRegular">
                <span>{{ formatedDate }}</span>
            </div>
            <div class="article-item__title-block">
                <!-- eslint-disable-next-line -->
                <html-link v-html="data.name"
                    :url="data.htmlUrl"
                    class="article-item__title">
                </html-link>
            </div>
            <div v-if="data.createdBy"
                class="article-item__description">
                {{ get(data, 'createdBy[0].name') }}
            </div>
            <div class="article-item__views"
                v-if="isRegular">
                <span v-if="data.views">
                    <svg-icon
                        name="icon-eye"
                        class="article-item__views-icon" />
                    {{ data.views.total }}
                </span>
            </div>
        </div>
        <html-link v-if="fullClickable"
            class="article-item__link"
            :aria-label="data.name"
            :url="data.htmlUrl" />
    </article>
</template>

<script>
import dayjs from 'dayjs'
import get from 'lodash/get'
import { mapGetters } from 'vuex'

export default {
    name: 'ArticleItem',
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        type: {
            type: String,
            default: null
        },
        fullClickable: {
            type: Boolean,
            default: false
        },
        imageSize: {
            type: String,
            default: ''
        }
    },
    computed: {
        isRegular() {
            return this.type !== 'news'
        },
        rootClasses() {
            return { 'article-item_news': !this.isRegular }
        },
        formatedDate() {
            return dayjs(this.data.createdAt).format(`DD.MM.YYYY ${this.$t('in')} HH:mm`)
        },
        ...mapGetters(['getNoImage']),
        computedPicture() {
            return (this.data.picture && this.data.picture.url)
                ? this.data.picture.url
                : this.getNoImage
        },
        size() {
            const size = this.imageSize.split('|');
            return {
                width: size[0] || null,
                height: size[1]
            };
        }
    },
    methods: {
        get,
    }
};
</script>

<style lang="less">
.article-item {
    font-size: rem(13);

    width: rem(130);

    position: relative;

    &__link {
        position: absolute;
        top: 0;
        right: 0;
        bottom: rem(5);
        left: 0;
    }

    &__picture {
        border-radius: rem(3);

        height: auto;
        width: auto;
        min-height: 100%;
        min-width: 100%;

        @{mobile} & {
            width: 100%;
            height: 100%;
        }

        &-wrapper {
            height: rem(107);
            width: 100%;
            position: relative;
            overflow: hidden;

            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: flex-start;

            &>img{
                object-fit: cover;
            }

            @{mobile} & {
                @media @landscape{
                    height: rem(214);
                }
            }
        }
    }

    &__publish-date {
        color: @color-gray;

        margin-top: rem(14);
    }

    &__title {
        color: @color-black;
        font-size: rem(13);
        font-weight: 500;
        line-height: 1.5;

        &:after {
            content: '';
            display: block;

            position: absolute;
            top: rem(5);
            right: rem(5);
            bottom: rem(5);
            left: rem(5);
        }

        &-block {
            display: -webkit-box;

            text-overflow: ellipsis;

            margin-top: rem(6);

            max-height: rem(60);

            overflow: hidden;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }

    &__views {
        display: flex;
        align-items: center;

        color: @color-gray-light;

        margin-top: rem(10.5);

        @{desktop} & {
            margin-top: rem(7);
        }
    }

    &__description {
        color: @color-gray;
        line-height: 2.4;
        white-space: nowrap;

        margin-top: auto;
    }

    &__views-icon {
        height: rem(16);
        width: rem(22);

        @{desktop} & {
            width: rem(16);
        }
    }

    &__name {
        display: flex;
        align-items: center;

        color: @color-gray;

        margin-top: rem(7.5)
    }

    &__picture + &__title-block {
        margin-top: rem(14);
    }

    &_news &__picture-block {
        display: flex;
        flex-direction: column;

        height: 100%;
    }

    &_news &__title {
        display: block;
    }

    &_news &__item {
        margin-bottom: rem(8);
    }

    &:hover &__title {
        @media @hover {
            color: @color-primary;
        }
    }
}
</style>
